/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Manager_TitleInputs */

const en_team_manager_title = /** @type {(inputs: Team_Manager_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Team Manager`)
};

const fr_team_manager_title = /** @type {(inputs: Team_Manager_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gestion d’équipe`)
};

const de_team_manager_title = /** @type {(inputs: Team_Manager_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teamleiter`)
};

const it_team_manager_title = /** @type {(inputs: Team_Manager_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Responsabile della squadra`)
};

const ru_team_manager_title = /** @type {(inputs: Team_Manager_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Менеджер команды`)
};

const es_team_manager_title = /** @type {(inputs: Team_Manager_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gerente de equipo`)
};

const zh_cn2_team_manager_title = /** @type {(inputs: Team_Manager_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`团队经理`)
};

const ja_team_manager_title = /** @type {(inputs: Team_Manager_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`チームマネージャー`)
};

const hi_team_manager_title = /** @type {(inputs: Team_Manager_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`दल प्रभंधक`)
};

const pt_pt2_team_manager_title = /** @type {(inputs: Team_Manager_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gerente de Equipe`)
};

/**
* | output |
* | --- |
* | "Team Manager" |
*
* @param {Team_Manager_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_title = /** @type {((inputs?: Team_Manager_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_team_manager_title(inputs)
	if (locale === "de") return de_team_manager_title(inputs)
	if (locale === "it") return it_team_manager_title(inputs)
	if (locale === "ru") return ru_team_manager_title(inputs)
	if (locale === "es") return es_team_manager_title(inputs)
	if (locale === "zh-CN") return zh_cn2_team_manager_title(inputs)
	if (locale === "ja") return ja_team_manager_title(inputs)
	if (locale === "hi") return hi_team_manager_title(inputs)
	if (locale === "pt-PT") return pt_pt2_team_manager_title(inputs)
	return en_team_manager_title(inputs)
});